<template>
  <section class="no-scrollbar flex h-[64px] overflow-x-auto">
    <div
      v-for="(item, idx) in 7"
      :key="item"
      class="flex w-[100px] shrink-0 flex-col items-center space-y-1.5"
    >
      <div
        v-if="idx === 1"
        class="bg-background-neutral-secondary border-background-positive-primary flex h-full w-full flex-col items-center justify-center space-y-1 overflow-hidden rounded-xl border-2 p-2"
      >
        <div class="shimmer green-shimmer h-[18px] w-10 rounded-2xl"></div>
        <div class="shimmer green-shimmer h-[22px] w-16 rounded-2xl"></div>
      </div>
      <div v-else class="flex flex-col items-center space-y-1 p-2">
        <div class="shimmer h-[18px] w-10 rounded-2xl"></div>
        <div class="shimmer h-[22px] w-16 rounded-2xl"></div>
      </div>
    </div>
  </section>
</template>

<style scoped>
  .green-shimmer {
    --shimmer-bg: #4ebc73;
  }
</style>
